import { UserOutlined } from '@ant-design/icons';
import { Avatar, Space, Tooltip, Typography } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';

import { CommentType } from '../../types';

const { Text } = Typography;

export default function CommentItem(comment: CommentType) {
    const datetime = DateTime.fromSQL(comment.created_at);

    return (
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
            <Space align="start">
                {/* {comment.avatar ? (
                    <Avatar src={comment.avatar} alt={comment.name} />
                ) : ( */}
                <Avatar icon={<UserOutlined />} alt={comment.commentator.name} />
                {/* )} */}
                <Space direction="vertical" size={0}>
                    <Space direction="horizontal" size={10}>
                        <Text strong>{comment.commentator.name}</Text>
                        <Tooltip title={datetime.toLocaleString(DateTime.DATETIME_MED)}>
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                {datetime.toRelative()}
                            </Text>
                        </Tooltip>
                    </Space>
                    <style>{`p { margin: 0 }`}</style>
                    <div
                        style={{ isolation: 'isolate' }}
                        dangerouslySetInnerHTML={{
                            __html: comment.text.replace(/(<? *script)/gi, 'illegalscript'),
                        }}
                    ></div>
                </Space>
            </Space>
        </Space>
    );
}
